export default __webpack_public_path__ + "static/media/ap-flowchart.a79d38b6.jpg";